import ProjectHeader, { latencyText } from "./ProjectHeader.jsx";

/**
 * Dashboard
 * Props:
 *   plan — { name, usedFeeds, totalFeeds }
 *   stats — { requests24h, changes24h (changed events, not detected changes),
 *             webhooksSent, failedDeliveries, responseTimes }
 *   projects — [{ id, name, url, feedCount, changes24h, mode, providerCount,
 *                 providers: [...], responseTimes }]
 *   onNewProject()
 *   onOpenProject(id)
 *   onOpenProvider(projectId, provider) — omitted for the overflow group, which
 *     has no hostname behind it to filter by
 *
 * The project list is a list of headers — see ProjectHeader. The tiles at the
 * top are the account-wide window, which is a different question from any one
 * project's and is labelled as such.
 */
export default function Dashboard({ plan, stats, projects = [], onNewProject, onOpenProject, onOpenProvider }) {
  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }}>
        <div>
          <p style={{ fontWeight: 500, fontSize: "var(--text-lg)", margin: 0 }}>Projects</p>
          <p style={{ fontSize: "var(--text-sm)", color: "var(--text-secondary)", margin: "2px 0 0" }}>
            {plan?.name} plan — {plan?.usedFeeds?.toLocaleString()} / {plan?.totalFeeds?.toLocaleString()} feeds
          </p>
        </div>
        <button className="ical-btn ical-btn-primary" onClick={onNewProject}>+ New project</button>
      </div>

      {/*
        Every tile says its window. The change tile counts changed *events* while
        a project's header counts detected changes — two different questions, and
        the labels have to keep them apart.
      */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(140px, 1fr))", gap: 12, marginBottom: 24 }}>
        <StatCard label="Requests (24h)" value={stats?.requests24h} />
        <StatCard label="Events changed (24h)" value={stats?.changes24h} />
        <StatCard label="Webhooks sent (24h)" value={stats?.webhooksSent} />
        <StatCard label="Failed deliveries (24h)" value={stats?.failedDeliveries} danger />
        <StatCard label="Response time (24h)" value={latencyText(stats?.responseTimes)} />
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
        {projects.map((project) => (
          <ProjectHeader
            key={project.id}
            project={project}
            onOpen={() => onOpenProject?.(project.id)}
            onOpenProvider={(provider) => onOpenProvider?.(project.id, provider)}
          />
        ))}
      </div>
    </div>
  );
}

function StatCard({ label, value, danger }) {
  return (
    <div className="ical-card">
      <p style={{ fontSize: "var(--text-sm)", color: "var(--text-secondary)", margin: "0 0 6px" }}>{label}</p>
      <p style={{ fontSize: "var(--text-2xl)", fontWeight: 500, margin: 0, color: danger && value > 0 ? "var(--text-danger)" : "var(--text-primary)" }}>
        {value?.toLocaleString?.() ?? value}
      </p>
    </div>
  );
}
